<template>
	<div>
		<app-header></app-header>
        <div>
            <v-container fluid grid-list-xl mt-7>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md10 lg7 sm12 class="col-height-auto">
                        <h1 class="fw-bold">{{$t("lostGoogleAuthentication.lostAccessApp")}}</h1>
                        <p class="font-lg mt-3">
                            {{$t("lostGoogleAuthentication.lostSecretkey")}}
                        </p>
                        <v-flex v-show="isShowLostHintMessage" xs12 md10 lg10 sm12 class="col-height-auto ml-2 font-lg">
                            <!-- <p class="font-lg">{{$t("lostGoogleAuthentication.sendEmailMessage")}}</p>
                            <ul class="font-1x">
                                <li>
                                    {{$t("lostGoogleAuthentication.emailAddressHint")}}
                                </li>
                                <li>
                                    {{$t("lostGoogleAuthentication.subjectHint")}}
                                </li>
                                <li>
                                    {{$t("lostGoogleAuthentication.descriptionHint")}}
                                </li>
                            </ul> -->
                            <p class="font-1x">{{$t("lostGoogleAuthentication.submitRequestMessageBefore")}}<a @click="goUserRequest">{{$t("lostGoogleAuthentication.customerService")}}</a>{{$t("lostGoogleAuthentication.submitRequestMessageAfter")}}</p>
                        </v-flex>
                        <p class="font-lg mt-3">
                            {{$t("lostGoogleAuthentication.haveSecretkey")}}
                        </p>
                        <v-flex v-show="isShowSendEmailForm" xs12 md10 lg10 sm12 ml-2 class="col-height-auto">
                            <p class="font-1x">{{$t("lostGoogleAuthentication.accepteEmail")}}</p>
                            <v-form ref="sendEmailForm" v-model="sendEmailValid">
                                <v-text-field v-model="sendEmailForm.regEmail" :rules="emailRules" :label="$t('lostGoogleAuthentication.email')" clearable required></v-text-field>
                                <v-text-field v-model="sendEmailForm.authenticationSecret" :rules="secretRules" :counter="16" 
                                :label="$t('lostGoogleAuthentication.secretKey')" clearable required></v-text-field>
                                <v-btn class="primary--text" outline :disabled="!sendEmailValid" @click="sendEmail">
                                    {{$t("common.submit")}}
                                </v-btn>
                            </v-form>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                isShowLostHintMessage: true,            //是否显示提示信息
                isShowSendEmailForm: true,              //是否显示发送邮件的表单
                sendEmailValid: true,                   //表单有效性
                sendEmailForm: {                        //发送邮件验证的表单
                    regEmail: null,
                    authenticationSecret: null
                },
                emailRules: [
                    v => !!v || this.$t("lostGoogleAuthentication.emailNotEmpty"),
                    v => /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(v) || this.$t("lostGoogleAuthentication.emailNotValid")
                ],
                secretRules: [
                    v => !!v || this.$t("lostGoogleAuthentication.secretKeyNotEmpty"),
                    v => (v && v.length == 16) || this.$t("lostGoogleAuthentication.secretKeyNotValid")
                ],
            }
        },
        computed: {

        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },        
        methods: {
            // 显示提示信息
            showLostHintMessage(){
                this.isShowLostHintMessage = !this.isShowLostHintMessage;
            },
            // 显示发送邮件的div
            showSendEmailDiv(){
                this.$refs.sendEmailForm.reset();
                this.isShowSendEmailForm = !this.isShowSendEmailForm;
            },
            // 发送邮件
            sendEmail(){
                if (this.$refs.sendEmailForm.validate()) {
                    let sendEmailUrl = config.baseUrl + "sendEmail/open/sendLostGoogleCodeEmail";
                    this.$http.post(sendEmailUrl, this.sendEmailForm).then(response => {
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.sendEmailValid = true;
                            this.$refs.sendEmailForm.reset();
                            // 发送成功
                            this.$Message.success({
                                content: this.$t("lostGoogleAuthentication.sendEmailSuccess"),
                                duration: 3
                            });
                        } else if (data.resCode == -1) {
                            //邮箱不存在
                            this.$Message.error({
                                content: this.$t("lostGoogleAuthentication.emailAddressNotExist"),
                                duration: 3
                            });
                        } else if (data.resCode == -2) {
                            //秘钥错误
                            this.$Message.error({
                                content: this.$t("lostGoogleAuthentication.secretKeyError"),
                                duration: 3
                            });
                        } else if (data.resCode == -10001) {
                            //邮件异常
                        }
                    });
                }
            },
            // 路由到提交请求页面
            goUserRequest(){
                this.$router.push({name:'userRequest'})
            },
        },

    }
</script>


// WEBPACK FOOTER //
// LostGoogleAuthentication.vue?4b01f696